import { DetailCard } from "../detail-card";
import { useTranslation } from "react-i18next";
import useSWR from "swr";
import { ReturnAnalyticsApi } from "../../../apis";
import { ResolutionTimeHistogram } from "../resolution-time-histogram";

interface IProps {
  dateFromIso?: string;
  dateToIso?  : string;
}

export function ResolutionTimeCard({ dateFromIso, dateToIso }: IProps) {
  const { t } = useTranslation("returns");
  const { data } = useSWR(
    ["returns.resolution-histogram", dateFromIso, dateToIso],
    () => ReturnAnalyticsApi.resolutionHistogram({ dateFrom: dateFromIso, dateTo: dateToIso }),
    { revalidateOnFocus: false }
  );

  return (
    <DetailCard title={t("dashboard.resolutionTime.title")}>
      <ResolutionTimeHistogram buckets={data?.buckets ?? []} />
    </DetailCard>
  );
}
